// 画像URL文字列データから画像URLのaタグを取得
export const getImageUrlStr = (imageStr) => {
  let re_el = "";
  if (imageStr == "" || imageStr == null) {
    return re_el;
  }

  // %r/uploads/をドメイン名 + /events/uploads/に置き換え
  let processedImageStr = imageStr;
  if (imageStr.includes("%r/uploads/")) {
    processedImageStr = imageStr.replace(
      "%r/uploads/",
      window.location.origin + "/events/uploads/"
    );
  }

  const parser = new DOMParser();
  const image_el = parser.parseFromString(processedImageStr, "text/html");
  const c_el = image_el.children[0].children[1].children[0].children[0];
  const url = c_el.attributes[0].nodeValue;

  return url;
};
